import { render, staticRenderFns } from "./RegisterValidate.vue?vue&type=template&id=3f28d212&scoped=true&"
import script from "./RegisterValidate.vue?vue&type=script&lang=js&"
export * from "./RegisterValidate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterValidate.vue?vue&type=style&index=0&id=3f28d212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28d212",
  null
  
)

export default component.exports